export default __webpack_public_path__ + "static/media/dr-seuss.0182c374.png";